/*
* AGP events
* Modules
*/

import $ from "jquery";
import 'jquery-ui';
require('jquery-ui/ui/widgets/sortable');

export default class Modules {


    init() {
        $("._tab_values").sortable({
            tolerance: 'pointer',
            axis: "y",
            classes: {
                "ui-sortable-help": "sortable_highlight_deux"
            }
        });

        $(document).on("click", "._add_value", function () {
            var _val = $("input[name=chp_value]").val();
            var _val_print = $("input[name=chp_value_print]").val();
            if(_val!=""){
                var _line = '<div class="_input_with_btn _input_value">' +
                    '<div class="_flex _flex_wrap">' +
                    '<div class="_flex _flex_wrap">' +
                    '<div class="col-xs-6 _c_input">' +
                    '<input type="text" name="chp_val[]" value="' + _val + '">' +
                    '</div>' +
                    '<div class="col-xs-6 _c_input">' +
                    '<input type="text" name="chp_val_print[]" value="' + _val_print + '">' +
                    '</div>' +
                    '</div>' +
                    '<div class="_flex _flex_wrap">' +
                    '<div class="_remove_value _inside_btn _flex_center"><i class="fa-solid fa-xmark"></i></div>' +
                    '<div class="_move_btn _flex _flex_center"><i class="fa-solid fa-up-down"></i></div></div>' +
                    '</div></div>';
                $("._tab_values").show().append(_line);
                $("input[name=chp_value]").val("");
                $("input[name=chp_value_print]").val("");
            }

        });

        $(document).on("click", "._remove_value", function () {
            $(this).parent().parent().parent().remove();
            if ($("._input_value").length == 0) {
                $("._tab_values").hide();
            }
        });

        /////////////////////////
        // Global sortable elements
        $(".reorder_ul").sortable({
            tolerance: 'pointer',
            axis: "y",
            cancel: ".cat",
            classes: {
                "ui-sortable-help": "sortable_highlight"
            },
            stop: function (event, ui) {

                var _this = $(this);

                var _multiple = $("input[name=sortable_multiples]").val();
                var _cat_id = $("input[name=sortable_cat]").val();

                if (_multiple === "true") {

                    var _id_c = $("input[name=sortable_id_cat]").val();

                    var _table = $("input[name=sortable_base_" + _id_c + "]").val();
                    var _chp_id = $("input[name=sortable_chp_id_" + _id_c + "]").val();
                    var _chp_order = $("input[name=sortable_chp_order_" + _id_c + "]").val();
                    var _nb = $("input[name=sortable_nb_" + _id_c + "]").val();
                } else {

                    var _table = $("input[name=sortable_base]").val();
                    var _chp_id = $("input[name=sortable_chp_id]").val();
                    var _chp_order = $("input[name=sortable_chp_order]").val();
                    var _nb = $("input[name=sortable_nb]").val();
                }

                if (_multiple === "true") {

                    var _array_id = $("input[name='sortable_order[" + _id_c + "][]']").map(function () {
                        //console.log($(this).val());
                        return $(this).val();
                    }).get();

                } else {
                    var _array_id = $("input[name='sortable_order[]']").map(function () {
                        return $(this).val();
                    }).get();
                }

                //console.log(_array_id);
                //return false;


                $.ajax({
                    url: _URL + "/move-orders",
                    data: {
                        table: _table,
                        chp_id: _chp_id,
                        chp_order: _chp_order,
                        nb: _nb,
                        chps: _array_id,
                        cat: _cat_id
                    },
                    type: "POST",
                    context: document.body
                }).done(function (response) {
                    console.log("move ok");
                    return false;
                });
            }
        });

    }
}